export const SmsSource = {
  CHECKOUT: 'checkout',
  MY_PLAN: 'my_plan',
};
